var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowContentProvider = void 0;
var Localize_1 = require("../../../gen-src/Localize");
var L10n_1 = require("../../localizationUtils/L10n");
var messages_1 = require("../../messages");
var MarkdownHtml_1 = require("../../utils/MarkdownHtml");
var notificationHelper_1 = require("../../utils/notificationHelper");
var MessagesWithEscapedMarkdown_1 = require("../MessagesWithEscapedMarkdown");
var NotificationDefaultProvider_1 = require("../NotificationDefaultProvider");
var FlowErrors_1 = require("./FlowErrors");
var FlowRunErrorMessage_1 = require("./FlowRunErrorMessage");
var FlowContentProvider = (function (_super) {
    __extends(FlowContentProvider, _super);
    function FlowContentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowContentProvider.prototype.getNotificationTitle = function (notification) {
        var content = notification.content;
        var flowName = content.flowName;
        if (content.numFailingTasks > 0) {
            return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.flowSuspensionMessage, { FLOW_NAME: flowName });
        }
        else {
            var errorCount = content.errors.length;
            return messages_1.Messages.flowFailedWithErrorsCount({
                FLOW_NAME: MarkdownHtml_1.escapeMarkdown(L10n_1.elideIfLong(flowName)),
                ERROR_COUNT: errorCount,
                ERROR_COUNT_LOC: Localize_1.Formatters.formatCount(errorCount),
            });
        }
    };
    FlowContentProvider.prototype.getNotificationContent = function (notification) {
        var content = notification.content;
        var flowName = notification.content.flowName;
        var maxDescriptionLength = notification.content.maxDescriptionLength;
        var errors = notification.content.errors;
        if (content.numFailingTasks > 0) {
            return messages_1.Messages.flowSuspensionStatusWithCount({
                FAILURE_COUNT: content.failureCount,
                FAILURE_COUNT_LOC: Localize_1.Formatters.formatCount(content.failureCount),
                SUSPENDED_TASK_COUNT: content.numFailingTasks,
                SUSPENDED_TASK_COUNT_LOC: Localize_1.Formatters.formatCount(content.numFailingTasks),
            });
        }
        return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.flowErrorMessage, {
            ERROR_MESSAGE: this.getStatusCodeMessage(errors[errors.length - 1], flowName, maxDescriptionLength),
        });
    };
    FlowContentProvider.prototype.getMaxShownContentLineCount = function () {
        return 8;
    };
    FlowContentProvider.prototype.getStatusCodeMessage = function (error, flowName, maxDescriptionLength) {
        var flowRunError = __assign(__assign({}, error), { flowRunErrorCode: error.errorCode, errorMessageParams: [error.errorMessageParam] });
        return (FlowErrors_1.FlowErrors.errorMessageFor({ flowName: flowName, errorCode: error.errorCode, maxDescriptionLength: maxDescriptionLength }, true) ||
            FlowRunErrorMessage_1.flowRunErrorMessageStrings(flowRunError));
    };
    FlowContentProvider.prototype.getErrorMessage = function (notification) {
        var _a;
        var urlError = notificationHelper_1.isNullOrUndefined((_a = notification.targetInfo) === null || _a === void 0 ? void 0 : _a.targetUrl);
        return urlError ? messages_1.Messages.flowNotFoundMessage() : '';
    };
    return FlowContentProvider;
}(NotificationDefaultProvider_1.NotificationDefaultProvider));
exports.FlowContentProvider = FlowContentProvider;
//# sourceMappingURL=FlowContentProvider.js.map